import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EntityBlank = _resolveComponent("EntityBlank")!
  const _component_CommonPage = _resolveComponent("CommonPage")!
  const _component_AlertWizard = _resolveComponent("AlertWizard")!
  const _component_SettingsPageLayout = _resolveComponent("SettingsPageLayout")!

  return (_openBlock(), _createBlock(_component_SettingsPageLayout, null, {
    default: _withCtx(() => [
      _createVNode(_component_CommonPage, {
        class: "annex-alarms-page",
        state: _ctx.commonPageState
      }, {
        "items-empty": _withCtx(() => [
          (_ctx.module.loaded && !_ctx.module.loading && _ctx.module.items.length === 0)
            ? (_openBlock(), _createBlock(_component_EntityBlank, {
                key: 0,
                "page-prefix": "alerts",
                "page-type": _ctx.state.pageType,
                "create-icon": "add",
                "has-create": _ctx.modelAcl.add,
                "is-empty": !_ctx.module.filter.hasChanges,
                onCreate: _ctx.handleCreate
              }, null, 8, ["page-type", "has-create", "is-empty", "onCreate"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["state"]),
      (_ctx.showNewItemWizard && _ctx.newItemModule)
        ? (_openBlock(), _createBlock(_component_AlertWizard, {
            key: 0,
            item: _ctx.newItemModule.item,
            onClose: _ctx.closeWizard,
            onSave: _ctx.saveItem
          }, null, 8, ["item", "onClose", "onSave"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}